import type { QueryFunctionContext } from '@tanstack/react-query';
import { queryOptions } from '@tanstack/react-query';
import { apiClient } from 'lib/api';
import type { FacebookCreativeAdDetailsDTO } from './types';
import type { AxiosResponse } from 'axios';
import { parseAdsLibraryApiPath } from './parseAdsLibraryApiPath';

interface Params {
  id: string;
  network?: string;
  region?: string;
  date_from?: string;
  date_to?: string;
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const composeRequestParams = ({ network, region, ...restParams }: Params) => {
  return { ...restParams };
};

export const getFBCreativeById = async ({
  signal,
  queryKey,
}: QueryFunctionContext<[string, string, ReturnType<typeof composeRequestParams>]>): Promise<FacebookCreativeAdDetailsDTO> => {
  const res = await apiClient.get<FacebookCreativeAdDetailsDTO, AxiosResponse<FacebookCreativeAdDetailsDTO>>(
    queryKey[1],
    {
      params: queryKey[2],
      signal,
    }
  );
  return res.data;
};

export const getFBCreativeByIdOptions = (params: Params) =>
  queryOptions({
    staleTime: 60 * 60 * 1000,
    queryFn: getFBCreativeById,
    queryKey: [
      'fb-ads-creative-by-id',
      parseAdsLibraryApiPath(`ad_creatives/${params.id}`, { network: params.network, region: params.region }),
      composeRequestParams(params),
    ] as const,
  });
